import { Component, Injector } from '@angular/core';
import { localizationKeys } from '../../../utils/localizationKeys';
import { BasePageComponent } from './../../base.page';

@Component({
    selector: 'app-bexio-error-page',
    templateUrl: './bexio-error.page.html',
    styleUrls: ['./bexio-error.page.scss'],
})
export class BexioErrorPage extends BasePageComponent {
    localizationKeys = localizationKeys;
    constructor(injector: Injector) {
        super(injector);
    }
}
